export const MODULE_NAME = "communication";

export const notificationStatusMap = {
  read: "Read",
  unread: "UnRead",
};
